import { render, staticRenderFns } from "./resetConfirm.vue?vue&type=template&id=4d5f5fcc&"
import script from "./resetConfirm.vue?vue&type=script&lang=js&"
export * from "./resetConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports